import { TaskRecord, TaskRecordFields } from '../../../state_manager/data_models/task_record.ts'

/**
 * Canonical task sort order used in TasksSection and TaskListMini (cards).
 * - Open tasks first, completed tasks second
 * - Open: sort by sort_order ASC when present, else by created_at DESC (newest first)
 * - Completed: sort by completed_on DESC (most recent first), nulls last
 */
export function sortTasksCanonical(tasks: TaskRecord[]): TaskRecord[] {
  const open: TaskRecord[] = []
  const completed: TaskRecord[] = []

  for (const t of tasks) {
    if (t[TaskRecordFields.tasks__completed]) {
      completed.push(t)
    } else {
      open.push(t)
    }
  }

  open.sort((a, b) => {
    const orderA = a[TaskRecordFields.tasks__sort_order]
    const orderB = b[TaskRecordFields.tasks__sort_order]
    if (orderA != null && orderB != null) {
      return orderA - orderB
    }
    if (orderA != null) return -1
    if (orderB != null) return 1
    const dateA = a[TaskRecordFields.tasks__created_at]
    const dateB = b[TaskRecordFields.tasks__created_at]
    if (!dateA && !dateB) return 0
    if (!dateA) return 1
    if (!dateB) return -1
    return new Date(dateB).getTime() - new Date(dateA).getTime()
  })

  completed.sort((a, b) => {
    const dateA = a[TaskRecordFields.tasks__completed_on]
    const dateB = b[TaskRecordFields.tasks__completed_on]
    if (!dateA && !dateB) return 0
    if (!dateA) return 1
    if (!dateB) return -1
    return new Date(dateB).getTime() - new Date(dateA).getTime()
  })

  return [...open, ...completed]
}
